.root {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--paletteNeutral0);
  border-radius: var(--radiusMd);
  background: var(--paletteNeutral2);
}

.headerContainer {
  display: flex;
  justify-content: space-between;
  gap: var(--spacingSm);
  padding: var(--spacingSm);
  border-bottom: 1px solid var(--paletteNeutral0);
}

.header {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacingMd);
  height: 2rem;
}

.content {
  padding: var(--spacingLg);
}
